import React from 'react';

import { Loader } from '../.';
import { useAppSelector } from 'redux/hooks';
import type { IframePage } from "types/iframe";
import { withParamsFrame } from 'HOCs';

const Barcodes: React.FC<IframePage> = ({ params }) => {
    const [httpParams] = React.useState(params);
    const [loaded, setLoaded] = React.useState(false);

    const { sellerId } = useAppSelector(({ sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
    }))

    return (
        <>
            <div className='xs:mx-3'>
                <iframe className={`${!loaded ? 'min-h-[auto]' : 'page-iframe'}`} src={`https://lk.market/${sellerId}/pim/barcodes${httpParams}`}
                    title="Products"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}
                    onLoad={() => setLoaded(true)}
                ></iframe>
            </div>
            {
                !loaded && <Loader />
            }
        </>
    );

}
export default withParamsFrame(Barcodes);
